import React from 'react';
import { linksInfo } from './mainData.js';
import { Link, useNavigate } from 'react-router-dom';


const Main = () => {
  const navigate = useNavigate();
  const { userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

  return (
    <div className="pb-5 overflow-hidden">
      <h2 className="text-2xl mb-6 md:mb-10 text-center">صفحه‌ها:</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12 justify-items-center">
        {linksInfo.map((item, index) => {
          return item.roles.includes(userRole.id) ? (
            <Link
              key={`link_${index}`}
              to={item.to}
              className="text-primary
                text-lg text-center transition-all hover:scale-125
                flex flex-col items-center justify-center"
            >
              <div>
              {item.icon}
              </div>
              {item.text}
            </Link>
          ) : null
        })}
      </div>
    </div>
  );
}

export default Main;
